export default __webpack_public_path__ + "static/media/CYAN.60c5b010.png";